import { getCookie } from 'app/lib/lib';
var TranslateService = /** @class */ (function () {
    // inject our translations
    function TranslateService(_translations) {
        this._translations = _translations;
        this._currentLang = 'ru';
        this.use(getCookie('i18n') || 'ru');
    }
    Object.defineProperty(TranslateService.prototype, "currentLang", {
        get: function () {
            return this._currentLang;
        },
        enumerable: true,
        configurable: true
    });
    TranslateService.prototype.use = function (lang) {
        this._currentLang = lang;
    };
    TranslateService.prototype.translate = function (key) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        var translation = key, me = this;
        var i18n = me._translations[me.currentLang];
        if (i18n) {
            var levels = key.split('.');
            while (levels.length > 0 && i18n) {
                i18n = i18n[levels.shift()];
            }
            if (!i18n) {
                //console.log(`i18n for path "${key}" not found!`);
                return key;
            }
            // Заменяем %1, %2 и т.д. на переданные значения из второго параметра вызова:
            // instant('какой-то текст %1, %2, %3', [123, '456', new Date()])
            return i18n.replace(/%\d/g, function () { return params.shift(); });
        }
        return translation;
    };
    TranslateService.prototype.instant = function (key) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        return this.translate.apply(this, [key].concat(params));
    };
    TranslateService.prototype.__ = function (key) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        return this.instant.apply(this, [key].concat(params));
    };
    TranslateService.prototype.__A = function (key) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        return this.instant.apply(this, ["adminstat." + key].concat(params));
    };
    return TranslateService;
}());
export { TranslateService };
